import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '../../abstract/base.component';

/**
 * Thin shell: hosts the child routes (list/detail/create/edit/cards/bank accounts).
 * Each child owns its own page header now (payarc-page-header), so this shell renders
 * no chrome of its own beyond the default-route redirect.
 */
@Component({
    selector: 'app-customers',
    templateUrl: './customers.component.html',
    styleUrls: ['./customers.component.css'],
    standalone: false
})
export class CustomersComponent extends BaseComponent {
  constructor(_router: Router) {
    super();
    this.router = _router;
  }
  onActivate() {
    document.getElementsByClassName('page-container')[0].scrollTop = 0;
  }
}
